/* eslint-disable @next/next/no-img-element */
import {doPasswordReset} from "@/services/auth";
import React, {useState} from "react";

const LoginFields = ({
                         onSubmit,
                         isSigningIn,
                         setEmail,
                         email,
                         onGoogleSignIn,
                         onAppleSignIn,
                         step,
                         errorMessage,
                         handleSteps,
                         switchMode,
                         password,
                         setPassword
                     }: any) => {
    const [emailReset, setEmailReset] = useState("")
    const [isResettingPassword, setIsResettingPassword] = useState(false);

    function handleResetPassword(){
        setIsResettingPassword(true);
        doPasswordReset(emailReset)
            .then(() => {
                alert("Email di recupero inviata!");
                setIsResettingPassword(false)
                setEmailReset("");
                handleSteps("passwordLogin");
            })
            .catch((error) => {
                console.error("Error sending password reset email:", error);
                alert("Errore durante l'invio dell'email di recupero.");
                setIsResettingPassword(false)
            });
    }
    return (

        <form onSubmit={onSubmit} className="space-y-4">

            {/* Step 1: Email */}
            {step === "email" && (
                <>
                    <h3 className="font-heading text-gray-800 text-xl font-semibold sm:text-2xl mt-2 text-center">
                        Accedi a <span className="text-[#EA5D39]">Babalù®</span>
                    </h3>
                    <p className="font-paragraph text-sm text-gray-600 text-center mt-2 mb-4">
                        Per procedere con l&apos;acquisto è necessario effettuare l&apos;accesso
                    </p>
                    {/* Pulsanti Google / Apple */}
                    <div className="flex flex-col space-y-3 mt-4 font-paragraph">
                        <button
                            disabled={isSigningIn}
                            onClick={onGoogleSignIn}
                            className={`
                    flex items-center justify-center gap-x-2 border border-gray-300 rounded-md py-2 
                    hover:bg-gray-50 transition 
                    ${isSigningIn ? "cursor-not-allowed opacity-60" : ""}
                  `}
                        >
                            <img
                                src="/assets/google-modale.svg"
                                alt="Google"
                                className="w-5 h-5"
                            />
                            <span className="text-sm font-medium">
                    {isSigningIn ? "Signing In..." : "Procedi con Google"}
                  </span>
                        </button>

                        <button
                            disabled={isSigningIn}
                            onClick={onAppleSignIn}
                            className={`
                    flex items-center justify-center gap-x-2 border border-gray-300 rounded-md py-2
                    bg-black text-white hover:bg-gray-800 transition
                    ${isSigningIn ? "cursor-not-allowed opacity-60" : ""}
                  `}
                        >
                            <img
                                src="/assets/apple-modale.svg"
                                alt="Apple"
                                className="w-5 h-5"
                            />
                            <span className="text-sm font-medium">
                    {isSigningIn ? "Signing In..." : "Procedi con Apple"}
                  </span>
                        </button>

                        {/* Bottone “Continua” (non fa submit, passa allo step password) */}
                        <button
                            type="button"
                            onClick={() => handleSteps("passwordLogin")}
                            className="
                  w-full
                  bg-[#026E78FF]
                  text-white
                  py-2
                  rounded
                  hover:bg-[#027E78FF]
                  transition
                  text-sm font-medium
                "
                        >
                            Accedi usando la tua email
                        </button>
                    </div>

                {/*    {errorMessage && (*/}
                {/*        <span className="font-paragraph text-red-600 font-bold block mt-2">*/}
                {/*  {errorMessage}*/}
                {/*</span>*/}
                {/*    )}*/}

                    {/* Link “Non hai un account? Registrati” */}
                    <div className="text-center text-sm font-paragraph">
                        <span className="text-gray-700">Non hai un account? </span>
                        <button
                            onClick={switchMode}
                            className="font-medium text-[#EA5D39] hover:underline"
                        >
                            Registrati
                        </button>
                    </div>
                </>
            )}

            {step === "resetPassword" && (
                <>
                    <h3 className="font-heading text-gray-800 text-xl font-semibold sm:text-2xl mt-2 text-center">
                        Hai dimenticato la password?
                    </h3>
                    <div className="font-paragraph">
                        <label className="block text-sm text-gray-700 font-bold mb-1">
                            Indirizzo e-mail
                        </label>
                        <input
                            type="email"
                            autoComplete="email"
                            required
                            value={emailReset}
                            onChange={(e) => setEmailReset(e.target.value)}
                            className="w-full mt-1 px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:ring-1 focus:ring-[#EA5D39]"
                            placeholder="Inserisci il tuo indirizzo e-mail"
                        />
                    </div>
                    <div
                        onClick={handleResetPassword}
                        className={`
                  w-full 
                  mt-4
                  bg-[#026E78FF]
                  text-white 
                  py-2 
                  text-center
                  cursor-pointer
                  rounded 
                  hover:bg-[#027E78FF]
                  transition
                  font-paragraph
                  ${isResettingPassword ? "cursor-not-allowed opacity-60" : ""}
                `}
                    >
                        {isResettingPassword ? "Sto inviando..." : "Recupera"}
                    </div>
                </>
            )}

            {/* Step 2: Password */}
            {step === "password" && (
                <>
                    <h3 className="font-heading text-gray-800 text-xl font-semibold sm:text-2xl mt-2 text-center">
                        Accedi a <span className="text-[#EA5D39]">Babalù®</span>
                    </h3>
                    <p className="font-paragraph text-sm text-gray-600 text-center mt-2 mb-4">
                        Per procedere con l&apos;acquisto è necessario effettuare l&apos;accesso
                    </p>
                    {/* Campo E-mail */}
                    <div className="font-paragraph">
                        <label className="block text-sm text-gray-700 font-bold mb-1">
                            Indirizzo e-mail
                        </label>
                        <input
                            type="email"
                            autoComplete="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full mt-1 px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:ring-1 focus:ring-[#EA5D39]"
                            placeholder="Inserisci il tuo indirizzo e-mail"
                        />
                    </div>

                    <div className="mt-4 font-paragraph">
                        <label className="block text-sm text-gray-700 font-bold mb-1">
                            Password
                        </label>
                        <input
                            type="password"
                            autoComplete="current-password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full mt-1 px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:ring-1 focus:ring-[#EA5D39]"
                            placeholder="Inserisci la tua password"
                        />
                        <div className="text-right mt-1">
                            <a
                                href="#"
                                className="text-sm text-[#EA5D39] hover:underline font-paragraph"
                                onClick={() => {
                                    handleSteps("resetPassword");
                                }}
                            >
                                Hai dimenticato la password?
                            </a>
                        </div>
                    </div>

                    {errorMessage && (
                        <span className="font-paragraph text-red-600 font-bold block mt-2">
                  {errorMessage}
                </span>
                    )}

                    <button
                        type="submit"
                        disabled={isSigningIn}
                        className={`
                  w-full 
                  mt-4
                  bg-[#026E78FF]
                  text-white 
                  py-2 
                  rounded 
                  hover:bg-[#027E78FF]
                  transition
                  font-paragraph
                  ${isSigningIn ? "cursor-not-allowed opacity-60" : ""}
                `}
                    >
                        {isSigningIn ? "Sto accedendo..." : "Accedi"}
                    </button>

                    <div className="text-center text-sm mt-2 font-paragraph">
                        <span className="text-gray-700">Non hai un account? </span>
                        <button
                            onClick={switchMode}
                            className="font-medium text-[#EA5D39] underline"
                        >
                            Registrati
                        </button>
                    </div>
                </>
            )}
        </form>
    )
}

export default LoginFields;
